import { ClientResponse } from "./clientResponse.model";
import { OrderDetailResponse } from "./orderDetailResponse.model";

export class QueryBalance {
  public typeFua: string;
    public idClient: number;
    public document: number;
    public typeDocument: number;
    public balance: number;
    public informationId: number;
    public code: string;
  constructor(
  ) { }

}